import {
  CLEAN_DETAIL_ORDER_VINCULATION_LIST,
  CLEAN_DETAIL_ORDER_VINCULATION_LIST_ERROR,
} from '_models/redux/types';

export const orderVinculationDetailListClean = () => async (dispatch) => {
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_DETAIL_ORDER_VINCULATION_LIST,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_DETAIL_ORDER_VINCULATION_LIST_ERROR,
    });
  }
};
